import PropTypes from 'prop-types';
import React from 'react';
import SecondaryNav from '../../Common/containers/SecondaryNav';

function RugbyLeagueNav({open, opener}) {
  const props = {
    open,
    opener,
    title: "Rugby League",
    links: [
      {href: "/rugby-league", text: "News", isIndex: true}
    ]
  };

  return (
    <SecondaryNav {...props}/>
  );
}

RugbyLeagueNav.propTypes = {
  open: PropTypes.bool.isRequired,
  opener: PropTypes.func.isRequired
}

export default RugbyLeagueNav



// WEBPACK FOOTER //
// ./modules/RugbyLeague/nav/RugbyLeagueNav.js